import {
	DataTable,
	DataTableContent,
	DataTableBody,
	DataTableRow,
	DataTableCell,
} from '@rmwc/data-table';
import classnames from 'classnames';

const TransformedDataTable = ({ headers, rows, className }) => {
	const transformedRows = headers.map((header, headerIndex) => {
		const cells = rows.map(row => row.Cells[header.Value]);
		return {
			Key: header.Value,
			Cells: {
				Header: { Value: header.Value },
				Value: { Value: cells.map(cell => cell?.Value).join(', ') },
			},
		};
	});

	return (
		<DataTable className={classnames('mdc-data-table', className)}>
			<DataTableContent>
				<DataTableBody>
					{transformedRows.map((row, rowIndex) => (
						<DataTableRow
							key={row.Key}
							className='mdc-data-table__row'
						>
							<DataTableCell className='mdc-data-table__cell data-table__cell--header'>
								{row.Cells.Header.Value}
							</DataTableCell>
							<DataTableCell className='mdc-data-table__cell'>
								{row.Cells.Value.Value}
							</DataTableCell>
						</DataTableRow>
					))}
				</DataTableBody>
			</DataTableContent>
		</DataTable>
	);
};

export default TransformedDataTable;
